import React from 'react';
import classNames from 'classnames';
import { fireTag } from '../../../libs/analytics';

const DropdownItem = ({id, name, func, type, selectedItem, districtInfo}) => {

	let value, propsValue, zoom;

	if (name !== undefined) {
		// eslint-disable-next-line prefer-destructuring
		value = name.split('.')[1];
		propsValue = `${type}:${name}`;
	}

	if (districtInfo !== undefined) {
		value = districtInfo.display;
		zoom = districtInfo.zoom;
		propsValue = `${type}:${districtInfo.numeral}.${districtInfo.display}:${districtInfo.zoom}`;
	}

	if (selectedItem === 'State') {
		selectedItem = "All States";
	}
	else if (selectedItem === 'District') {
		selectedItem = "All Districts";
	}

	return (
		// eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
		<li
			id={id}
			key={id}
			className={classNames('list-group-item', value === selectedItem ? 'selected' : '')}
			data-zoom={zoom}
			onClick={()=>{
				if(selectedItem === 'All States'){
					//fireTag('C2',value.toLowerCase())
				} else if(selectedItem === 'All Districts'){
					//fireTag('C3',value.toLowerCase())
				}
				func(propsValue);
			}}
			onKeyDown={event => {
				if (event.key === 'Enter') {
					if(selectedItem === 'All States'){
						//fireTag('C2',value.toLowerCase())
					} else if(selectedItem === 'All Districts'){
						//fireTag('C3',value.toLowerCase())
					}
					func(propsValue);
				}
			}}
			// eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
			tabIndex="0"
		>
			{value === selectedItem && (
				<span className="list-item-checkmark"><div className="icon-checkmark"/></span>
			)}
			{value}
		</li>
	)

};

export default DropdownItem;
